<mat-card class="success-container">
  <div class="login-link-container">
    <p class="login-link" (click)="backToLogin()">{{ 'login' | translate }}</p>
  </div>
  <mat-card-header>
    <img class="image-size" src="assets/themes/{{ themeService.currentLogo }}" />
  </mat-card-header>
  <mat-card-content>
    <mat-card-content>
      <ng-container *ngIf="EMAIL_SERVER_ACTIVE; else passwordChanged">
        <h1>{{ 'pwd-change-email-title' | translate }}</h1>
        <h2>{{ 'pwd-change-email-message' | translate }}</h2>
      </ng-container>
      <ng-template #passwordChanged>
        <h1>{{ 'pwd-change-no-email-title' | translate }}</h1>
        <h2>{{ 'pwd-change-no-email-message' | translate }}</h2>
      </ng-template>
    </mat-card-content>
  </mat-card-content>
  <!--
    <mat-card-actions>
    <h2>
      {{ 'cant-see' | translate }}
    </h2>
    <button mat-raised-button color="primary" (click)="resendLink()">
      {{ 'resend-link' | translate }}
    </button>
    </mat-card-actions>
  -->
</mat-card>
